import {createReducer} from 'redux-act';
import Cookies from 'js-cookie';
import {
  GET_EMAIL_MARKETING_TRIAL_DATE,
  GET_MARKETING_STATISTIC_SUCCESS,
  OPEN_CONTACT_FORM_MODAL,
  OPEN_INFORMATION_MODAL,
  SET_EMAIL_MARKETING_RESULT_PAGE_SPINNER,
  SET_EMAIL_MARKETING_TRIAL_DATE,
  GET_EMAIL_MARKETING_CAMPAIGNS_SUCCESS,
  GET_EMAIL_MARKETING_CAMPAIGNS_FAILURE,
  RESET_EMAIL_MARKETING_CAMPAIGNS,
  SET_EMAIL_MARKETING_CAMPAIGNS_SPINNER,
  SET_EMAIL_MARKETING_CAMPAIGNS_PAGE,
  SET_EMAIL_MARKETING_CAMPAIGNS_FILTERS,
  GET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SUCCESS,
  SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER,
  CLEAR_EMAIL_MARKETING_CAMPAIGN_DETAIL,
  GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SUCCESS,
  GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_FAILURE,
  SET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SPINNER
} from 'store/emailMarketing/action';
import {
  COOKIE_NAME_EMAIL_MARKETING_COUNTDOWN,
  CAMPAIGNS_PAGE_SIZE,
  CAMPAIGN_STATUS_ALL
} from 'helpers/constants/emailMarketing';

const initialState = () => ({
  isOpenModal: false,
  isOpenInformationModal: false,
  statistic: {
    lastMonthSummary: {
      sent: 0,
      delivered: 0,
      salesDriven: 0
    },
    allSummary: {
      sent: 0,
      delivered: 0,
      salesDriven: 0
    }
  },
  spinner: false,
  emailMarketingTrialDate: null,
  emailMarketingTrialDateStatus: null,
  campaignsSummary: null,
  campaigns: [],
  campaignsPaging: {
    page: 1,
    pageSize: CAMPAIGNS_PAGE_SIZE,
    total: 0
  },
  campaignsFilters: {
    status: CAMPAIGN_STATUS_ALL,
    search: ''
  },
  campaignsSpinner: false,
  campaignsError: false,
  campaignDetail: null,
  campaignDetailSpinner: false,
  campaignPreview: null,
  campaignPreviewSpinner: false,
  campaignPreviewError: false
});

const emailMarketingReducer = createReducer(
  {
    [OPEN_CONTACT_FORM_MODAL]: (state, payload) => ({
      ...state,
      isOpenModal: payload
    }),
    [OPEN_INFORMATION_MODAL]: (state, payload) => ({
      ...state,
      isOpenInformationModal: payload
    }),
    [GET_MARKETING_STATISTIC_SUCCESS]: (state, payload) => ({
      ...state,
      statistic: payload,
      spinner: false
    }),
    [SET_EMAIL_MARKETING_RESULT_PAGE_SPINNER]: (state, payload) => ({
      ...state,
      spinner: payload
    }),
    [SET_EMAIL_MARKETING_TRIAL_DATE]: (state, payload) => {
      const result = Cookies.get(COOKIE_NAME_EMAIL_MARKETING_COUNTDOWN)
        ? null
        : {
            emailMarketingTrialDate: payload.startDate,
            emailMarketingTrialDateStatus: payload.status
          };
      return {
        ...state,
        ...result,
        spinner: false
      };
    },
    [GET_EMAIL_MARKETING_TRIAL_DATE]: (state) => {
      return {
        ...state,
        spinner: true
      };
    },
    [GET_EMAIL_MARKETING_CAMPAIGNS_SUCCESS]: (state, payload) => ({
      ...state,
      campaignsSummary: payload?.summary || null,
      campaigns: payload?.campaigns?.items || [],
      campaignsPaging: {
        page: payload?.campaigns?.page || 1,
        pageSize: payload?.campaigns?.pageSize || CAMPAIGNS_PAGE_SIZE,
        total: payload?.campaigns?.total || 0
      },
      campaignsSpinner: false,
      campaignsError: false
    }),
    [GET_EMAIL_MARKETING_CAMPAIGNS_FAILURE]: (state) => ({
      ...state,
      campaignsSummary: null,
      campaigns: [],
      campaignsPaging: {...state.campaignsPaging, total: 0},
      campaignsSpinner: false,
      campaignsError: true
    }),
    [SET_EMAIL_MARKETING_CAMPAIGNS_SPINNER]: (state, payload) => ({
      ...state,
      campaignsSpinner: payload
    }),
    [SET_EMAIL_MARKETING_CAMPAIGNS_PAGE]: (state, payload) => ({
      ...state,
      campaignsPaging: {...state.campaignsPaging, page: payload}
    }),
    // Page and filters belong to the location they were chosen on, so a new one
    // starts from scratch instead of querying an offset that may not exist there.
    [RESET_EMAIL_MARKETING_CAMPAIGNS]: (state) => ({
      ...state,
      campaignsSummary: null,
      campaigns: [],
      campaignsPaging: {page: 1, pageSize: CAMPAIGNS_PAGE_SIZE, total: 0},
      campaignsFilters: {status: CAMPAIGN_STATUS_ALL, search: ''},
      campaignsError: false
    }),
    // A filter or search change invalidates the current offset, so always drive
    // back to the first page with it.
    [SET_EMAIL_MARKETING_CAMPAIGNS_FILTERS]: (state, payload) => ({
      ...state,
      campaignsFilters: {...state.campaignsFilters, ...payload},
      campaignsPaging: {...state.campaignsPaging, page: 1}
    }),
    [GET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SUCCESS]: (state, payload) => ({
      ...state,
      campaignDetail: payload,
      campaignDetailSpinner: false
    }),
    [SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER]: (state, payload) => ({
      ...state,
      campaignDetailSpinner: payload
    }),
    [CLEAR_EMAIL_MARKETING_CAMPAIGN_DETAIL]: (state) => ({
      ...state,
      campaignDetail: null,
      campaignPreview: null,
      campaignPreviewError: false
    }),
    [GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SUCCESS]: (state, payload) => ({
      ...state,
      campaignPreview: payload,
      campaignPreviewSpinner: false,
      campaignPreviewError: false
    }),
    [GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_FAILURE]: (state) => ({
      ...state,
      campaignPreview: null,
      campaignPreviewSpinner: false,
      campaignPreviewError: true
    }),
    [SET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SPINNER]: (state, payload) => ({
      ...state,
      campaignPreviewSpinner: payload
    })
  },
  initialState()
);

export default emailMarketingReducer;
